// extracted by mini-css-extract-plugin
export default {"container":"EasyCrop_container__Mgf8J","saveButton":"EasyCrop_saveButton__UPBGJ","cropContainer":"EasyCrop_cropContainer__-5C9U","controls":"EasyCrop_controls__iXa6E"};